import { connect } from 'react-redux';

import { hideModal } from '../../../../actions/ModalActions';
import { removeOrRevokePartner } from '../../../../actions/AccountInvitationActions';
import * as NotificationActions from '../../../../actions/NotificationActions';

import { getActiveOrInvitedPartner } from '../../../../selectors/checklist/checklistSelectors';

import ChecklistRemoveOrRevokeModal from './ChecklistRemoveOrRevokeModal';

const mapStateToProps = state => ({
  partnerStatus: getActiveOrInvitedPartner(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeOrRevokePartner: (uuid, acceptedAt) => {
    const action = acceptedAt ? 'remove' : 'revoke';

    if (!uuid) return;

    dispatch(removeOrRevokePartner(uuid, action)).then(() => {
      dispatch(hideModal());

      if (ownProps.callback) ownProps.callback();

      const message = action === 'remove' ? 'Partner has been removed' : 'Invitation has been revoked';
      dispatch(NotificationActions.success({ message }));
    });
  },
  onCancel: () => dispatch(hideModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistRemoveOrRevokeModal);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistRemoveOrRevokeModal/index.js